module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABA0lEQVRYhe2XyQ7DIAxEx1X//5fdS5EcmrB5Qah+p5JG9gwYYoAkSY6GWn8ysz4BETNzM89kvMv4ZRW4k1Q/Ew+EGGBmNxMhBgA/E29tgBlRxYTlnlAbAOY2u7WJsBKSWJbTFgNEBKsVMCmh+myukSVmKR4wMNATI0vFWjwQWEIe4oG4L7GLeCDuS+wiHggw4Cke2HSMWpIGdpMGdnO8gd4R99Mxeh+LLb5tySV/txfaKXiE40touRuVXWZZpfKMmUneulq/WzHqd5YMPCWRpSXHMyXXi3GXZ9qAdg8UEXf3YItrpcmNbIWR2R3BbRPXs/60ClqWVqCIkWNtjNV3kuTf+QA4M7M+UiQfEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEFWD.png
// module id = 68
// module chunks = 0